import Vue from 'vue'
import Router from 'vue-router'
import * as Sentry from '@sentry/vue'
import { BrowserTracing } from '@sentry/tracing'
import config from '@/services/config'

import auth from '@/services/auth'
import routes from '@/routes'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
Sentry.init({
  Vue,
  dsn: config.sentryDsn,
  enabled: process.env.NODE_ENV === 'production',
  environment: process.env.NODE_ENV,
  integrations: [
    new BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracingOrigins: ['cloud.bloq.com', /^\//]
    })
  ],
  tracesSampleRate: 1.0
})

router.beforeEach(function (to, from, next) {
  const isValidAccessToken = auth.verifyToken()
  const isGoingToLogin = to.name === 'login'

  if (isGoingToLogin && isValidAccessToken) {
    return next({ name: from.name || 'console' })
  }

  if (!isGoingToLogin && to.meta.isPublic) {
    return next()
  }

  if (!isGoingToLogin && !isValidAccessToken) {
    return next({ name: 'login', query: { redirectUrl: to.fullPath } })
  }

  return next()
})

export default router
